import React, { useState } from 'react';
import { Button, Col, Row, Alert, Modal, ModalHeader, ModalBody, Card } from 'reactstrap';
import SubCard from '../base/components/SubCard';
// import { FCard, FilterForm, FPropControl } from '../base/components/FilterUI';
import C from '../C';
import ServerIO from '../plumbing/ServerIO';
import CopyButton from '../base/components/CopyButton';
import Misc from '../base/components/Misc';
import SavePublishDeleteEtc from '../base/components/SavePublishDeleteEtc';
import KStatus from '../base/data/KStatus';
import { getDataItem, getDataList } from '../base/plumbing/Crud';
import DataStore, { getDataPath } from '../base/plumbing/DataStore';
import SearchQuery from '../base/searchquery';
import { noVal, space } from '../base/utils/miscutils';
import PropControlDataItem from '../base/components/propcontrols/PropControlDataItem';
import PropControl from '../base/components/PropControl';
import KContentType from '../base/data/KContentType';
//import Wizard, {WizardStage} from '../base/components/WizardProgressWidget';
import List from '../base/data/List';
import { addFunderCredit } from '../base/components/AboutPage';
import { dateStr, dateUTCfromString } from '../base/utils/date-utils';
import { getStatus } from '../base/data/DataClass';
import {macroAdders, KMacroType} from '../base/data/GreenTag';
import { PreviewDisplayAd, STANDARD_SIZES, CREATIVE_SIZES, SizeToggle, previewCol } from './DisplayAdvertUtils';
import DevOnly from '../base/components/DevOnly';

function setTemplate({template, path}) {
	let templateBase = template.displayBase;
	let basePath = [...path, 'displayBase'];
	let brandingPath = [...path, 'branding'];
	let advancedPath = [...path, 'advanced'];

	DataStore.setValue([...basePath, "templateId"], template.id);
	DataStore.setValue([...basePath, "action"], templateBase.action);
	DataStore.setValue([...basePath, "noun"], templateBase.noun);
	DataStore.setValue([...basePath, "verb"], templateBase.verb);
	
	DataStore.setValue([...brandingPath, "backgroundImage"], template.branding.backgroundImage);
	DataStore.setValue([...brandingPath, "backgroundColor"], template.branding.backgroundColor);
	DataStore.setValue([...brandingPath, "customHtml"], template.branding.customHtml);
	DataStore.setValue([...brandingPath, "customCss"], template.branding.customCss);
	DataStore.setValue([...brandingPath, "color"], template.branding.color);
	DataStore.setValue([...brandingPath, "color2"], template.branding.color2);

	DataStore.setValue(advancedPath, template.advanced);
}

function TemplateList({advert, path, size}) {	
	//let pvAds = Advert.fetchForAdvertiser({status:KStatus.DRAFT});

	let q = new SearchQuery(`displayBase.isTemplate:true AND format:display AND displayBase.displaySize:${size}`);
	let pvAds = getDataList({ type: C.TYPES.Advert, status:KStatus.ALL_BAR_TRASH, q, save: true });

	const width = STANDARD_SIZES[size][0];
	const height = STANDARD_SIZES[size][1];
	const ratio = width + " / " + height;
	const previewWidth = size === "billboard" || size === "leaderboard" ? "100%" : "33%";
	const previewColCount = size === "billboard" || size === "leaderboard" ? 1 : 3;

	if(pvAds.resolved) {
		if(pvAds.value) {
			// resolved with data
			let ads = List.hits(pvAds.value);
			
			ads = ads.filter(ad => {
				if(ad.displayBase.isTemplate === false) return false;
				
				// check if template isn't brand locked OR this brand has permission	
				let perms = ad.displayBase.templatePermissionId;
				return (perms === "" || perms === advert.vertiser);
			});

			return (
			<div className="template-card">	
				<h1>Templates</h1>
				{ads.length > 0 ? 
					<>
					<p>Templates define the outer branding of your advert which includes
						<ul>
							<li>The background</li>
							<li>What good the ad does</li>
							<li>HTML & CSS affecting the outer advert</li>
							<li>Layer images</li>
						</ul>
						If you want a custom ad, reach out to our support team.
						??? Should more stuff go here ???
					</p>
						<div className="d-flex flex-wrap template-container">
							{
							// take this list and turn it into a series of buttons to let users change formats
							ads.map((ad, i) => {
								let adSelected = ad.id === advert.displayBase.templateId ? "selected" : "";
								return (
								<a className={`template-button ${adSelected}`} onClick={() => setTemplate({path:path, template:ad})} style={{background: `url(${ad.branding.backgroundImage}`, backgroundColor:ad.branding.backgroundColor, aspectRatio: ratio, width:previewWidth, marginTop: i >= previewColCount ? "2%" : "0"}}>
								<div className={`template-content d-flex ${adSelected}`} key={ad.id} style={{width:"100%", height:"100%"}}>
									<Col>
									<p>{ad.name || "unnamed"}</p>
									<small>ID: {ad.id}</small>
									<DevOnly style={{inlineSize:"fit-content"}}><a className='btn' href={`/#displayad/${ad.id}`}>Go to template</a></DevOnly>
									</Col>
								</div>
								</a>
								);
							}
							)}
						</div>
					</> 
					: 
					<>
					<h3>No templates available for selected format</h3>
					<p>Likely scenario is that no template has been created yet as this is still in development 👀🛠️</p>
					</>}
			</div>
			);
		}

		// resolved, no value
		return (
			<h2>No valid templates found!</h2>
		);
	}
	// not resolved
	return <Misc.Loading />;
}

function DetailsPage({ advert, path, isStaff, size }) {
	let campaignPv = advert.campaign && getDataItem({type:C.TYPES.Campaign, id:advert.campaign, status:KStatus.DRAFT});
	let campaign = campaignPv?.value;
	
	return (
		<>
			<Col className="content-col">
				<h1>Details</h1>
				<p className="text">
				Display Adverts are intended to be a cheaper & more plentiful alternative to our other adverts. Every ad will be priced on a dynamic amount, eg a brand gives a campaign limit and their donation is linked to the ads performance( 1000 views = 1 tree planted for example).
				<br /><br />
				The editor you see now is very much a WIP, so please give all the criticism you can to help make this as good it as it can be.
				<br /><br />
				Each ad is made of two key parts. The outer template & the inner creative. The outer template will depend on what charity the brand is donating to and *should* usually be mostly automated. This is our good-loop branded bit. The inner creative on the other hand is the brands own advertisement. 
				<br /><br />
				The intention is that this could eventually be given over to agencies as a self-serve tool and as such the page has a fairly drastically different look to normal portal. The intention is for this to be as simple a tool for these users as possible. 
				</p>
				<br />
				<Row>
					<Col><PropControl required label={!advert.name ? 'Enter a name for your Advert' : 'Advert Name'} path={path} prop="name" /></Col>
					<Col><PropControl required type="url" path={path} prop="url" label="Click through URL" help="If the creative is clicked, this is the webpage the user is brought to."/></Col>
				</Row>
				{!advert.displayBase.isTemplate && <Row className="d-flex justify-content-between">
					<Col><PropControl required label="Brand" path={path} prop="vertiser" type="DataItem" pageSize={10} itemType={C.TYPES.Advertiser} readOnly
						status={KStatus.PUB_OR_DRAFT} canCreate createProp="name"/></Col>

					<Col><PropControl required label="Campaign" path={path} prop="campaign" type="DataItem" pageSize={10} itemType={C.TYPES.Campaign}
						status={KStatus.PUB_OR_DRAFT} canCreate createProp="campaign" disabled={!advert.vertiser}/></Col>
					
					<Col>
					{campaign && campaign.agencyId && <PropControlDataItem required label="Agency" pageSize={0} readOnly path={getDataPath({status:KStatus.DRAFT, type:C.TYPES.Agency, id:campaign.agencyId})} id={campaign.agencyId} prop="id" itemType={C.TYPES.Agency} status={KStatus.DRAFT} />}
					{campaign && !campaign.agencyId && <Alert color="danger" className="align-self-center">Please set an Agency on the Campaign</Alert>}
					</Col>
					{!campaign && <div />}
				</Row>}
			</Col>
			{previewCol({ad:advert, path:path})}
		</>
	);
}

function DesignPage ({advert, path, size, isStaff}) {
	return <>
		<Col className="content-col">	
			<TemplateList advert={advert} path={path} size={size}/>
			<br/>
			<ContentCard advert={advert} path={path} isStaff={isStaff}/>
		</Col>
		{previewCol({ad:advert, path:path})}
		</>;
}


function ContentCard({ advert, path }) {
	let displayPath = [...path, 'displayBase'];
	let advertBranding = [...path, 'branding'];
	let creativeBranding = [...displayPath, 'creativeBranding'];

	let displayBase = DataStore.getValue(displayPath);
	let creativeBase = DataStore.getValue(creativeBranding);
	//if (!creativeBase?.customHtml) creativeBase.customHtml = "";

	let contentType = displayBase.contentType;
	
	const setContentType = (type) => {
		DataStore.setValue([...path, 'displayBase', 'contentType'], type);
		contentType = displayBase.contentType;
	};

	let size = advert.displayBase.displaySize;
	let editors = {
		RESPONSIVE_IMAGE: <PropControl required type="imgUpload" prop="backgroundImage" path={creativeBranding} help="Use an image as content for the display ad." />,
		HTML: <PropControl type="code" popup required lang="html" label="Custom HTML" prop="customHtml" path={creativeBranding} help="Use custom HTML to show as content for the display ad." />
	};

	return (
		<>
			<h1>Advert Creative</h1>
			<p>Recommended Creative Sizes (pixels)</p>
			<br />
			{size === "responsive" ? <></> : <><small>{`${size}: ${CREATIVE_SIZES[size][0]}x${CREATIVE_SIZES[size][1]}`}</small><br /></>}
			<div id="tadg-display-navbar" className="d-flex flex-row" style={{ height: "5vh", width: "100%" }}>
				<Button className={`${contentType===KContentType.RESPONSIVE_IMAGE && 'bg-info'} btn flex-grow-1`} onClick={() => setContentType(KContentType.RESPONSIVE_IMAGE)} style={{ borderRadius: "0" }}>Image</Button>
				<Button className={`${contentType===KContentType.HTML && 'bg-info'} btn flex-grow-1`} onClick={() => setContentType(KContentType.HTML)} style={{ borderRadius: "0" }}>HTML</Button>
			</div>
			{editors[contentType]}
		</>
	);
}

// top of design page, handles users selecting what size (mpu2, billboard, ...) they want to select (only one size selected allowed)
function FormatCard({ advert, vertiser, path, size }) {
	const [modalOpen, setModalOpen] = useState(false);
	const displayPath = path.concat("displayBase");
	const widget_sizes = DataStore.getValue(['widget', 'DisplayAd']) || {};

	const onClick = (newSize) => {
		console.log("oh fuck off (onClick() fired)");
		DataStore.setValue([...path, "displayBase", "displaySize"], newSize);
	};

	return <>
		<h1>Format</h1>

		<Button color="secondary" onClick={() => setModalOpen(true)}>See previews</Button>
		<Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} className="format-modal">
			<ModalHeader toggle={() => setModalOpen(!modalOpen)}>Select one or more formats</ModalHeader>
			<ModalBody>
				<SizeToggle size="responsive" curSize={size} advert={advert} displayPath={displayPath}/>
				<Row className={space('previews mt-3', Object.keys(STANDARD_SIZES).join(" "))}>
					<Col>
						<PreviewDisplayAd advert={advert} className={size === "mpu2" && "selected"} size="mpu2" curSize={size} onClick={(e) => onClick("mpu2")} path={path} selectable/>
					</Col>
					<Col className="horizontal-previews">
						<PreviewDisplayAd advert={advert} className={size === "leaderboard" && "selected"} size="leaderboard" curSize={size} path={path} onClick={(e) => onClick("leaderboard")} selectable/>
						<PreviewDisplayAd advert={advert} className={size === "billboard" && "selected"} size="billboard" curSize={size} path={path} onClick={(e) => onClick("billboard")} selectable/>
					</Col>
				</Row>
			</ModalBody>
		</Modal>
		<br />
	</>;
}

function ExportLink({title, text, link}) {
	return <SubCard className="export-link">
		<p>{title}</p>
		{link && text && <a href={text} target="_blank" rel="noreferrer"><small>Link</small></a>}
		<div className="html-export">
			<small>
				{text ? <code>
					{text}
				</code> : <p>Not available</p>}
			</small>
		</div>
		{text && <CopyButton text={text}/>}
	</SubCard>;
}

function PublishPage({ advert, path, size, requiredToPublish}) {

	// TODO handle export of several sizes
	let sizeStr = "";
	if (size && size !== "responsive") {
		sizeStr += 'width="'+STANDARD_SIZES[size][0]+'"';
		sizeStr += ' height="'+STANDARD_SIZES[size][1]+'"';
		sizeStr += ' size="'+size+'"';
	}

	const adLink = `${ServerIO.AS_ENDPOINT}/display/${advert.id}/index.html${size ? "&size="+size : ""}`;
	const draftLink = `${ServerIO.AS_ENDPOINT}/display/demo/${advert.id}/index.html`;

	const demoSlugs = {
		mpu2: "double-mpu",
		billboard: "billboard"
	};
	const slug = demoSlugs[size];
	const demoLink = slug && `${ServerIO.DEMO_ENDPOINT}/desktop/display/${slug}?gl.vert=${advert.id}&status=DRAFT`;

	// KMacroType macroAdder

	let requiredDataExists = requiredToPublish.reduce((totalMissing, curVal) => {
		try {
			let value = DataStore.getValue(curVal[1]);
			let missingValue = noVal(value) || value === "" || (value.length && value.length === 0);
			if(!missingValue) return totalMissing;
			return [...totalMissing, <li>{curVal[0]}</li>];
		} catch {
			return totalMissing;
		} 
	}, []);

	let missingDataWarning = <SubCard><h3>Steps still required:</h3><ul>{requiredDataExists}</ul></SubCard>;

	if(requiredDataExists.length > 0) {
		return (
			<>
			<Col className="content-col">
				<Alert color="warning" className="text-center"><h2>There's still required steps that need completing and cannot publish.</h2></Alert>
				{missingDataWarning}
			</Col>
			{previewCol({ad:advert, path:path})}
			</>
		);
	}
	// hacky dumb way of getting macros. Greentag uses an object to build its URL, this just fakes that to grab the macro url

	const labelMacroTypes = { NONE: 'No macros', DV360: 'Google DV360', GOOGLE: 'Google Ad Manager', TTD: 'TheTradeDesk', XANDR: 'Xandr / AppNexus', YAHOO: 'Yahoo', AMAZON: 'Amazon' };
	let macro = "";
	let test = {};
	test.search = "";
	let macro2 = macroAdders[DataStore.getValue(['widget', 'macroType'])];
	if(macro2 !== undefined && macro2 !== null) console.log(macro2((test)));
	macro = test.search;

	return <>
			<Col className="content-col">
				<h1>Publish</h1>
				<br />
				<Row>
					<Col><ExportLink title="Draft link:" text={`${draftLink}/?status=DRAFT${sizeStr ? `&${sizeStr.replaceAll(" ", "&").replaceAll("\"", "")}` : ""}`}/></Col>
					<Col><ExportLink title="Draft demo link:" text={demoLink} link/></Col>
				</Row>
			<div className="w-25"> 	
			</div>
			<Row>
					<Col><ExportLink title="HTML tag to insert:" text={`<iframe src="${adLink}" ${sizeStr} ${macro}></iframe>`}/></Col>
					<Col>
						<PropControl type="select" path={['widget']} prop="macroType" label="Macro Format" options={KMacroType.values} labels={labelMacroTypes} 
							dflt={null} help="Add DSP macros?" />
						<PropControl type="number" path={[...path, "advanced"]} prop="demoNumber" label="Demo number" 
							help="For demos before a campaign is run, it can be nice to show an example number instead of 0"/>
					</Col>
			</Row>

			<SavePublishDeleteEtc type={C.TYPES.Advert} id={advert.id} noSave position="relative" />
			</Col>
			{previewCol({ad:advert, path:path})}
		</>;
}

export {DetailsPage, DesignPage, PublishPage};
